<script context="module">
import fetch_param from './_fetch';
//import data1 from './_store';
	export async function preload({ host, path, params, query }, session) {
    let load;
    fetch_param.headers.host = host;
    if (query.str) {
      load = query.str
    } else {
      load = 'start'
    }
    const res = await this.fetch(`/api/str/${load}.txt`, fetch_param);
    const str = await res.json();
		
    //console.log(session);

		if (res.status === 200) {
     
			return { str };
		} else {
      this.error(res.status, str.message);
		}
  
	}
</script>

<script>

import Str from '../components/Str.svelte';
  export let str;
  export let segment;
</script>


  <div class="str-grid">
    {#if str}
      <Str str={str}></Str>
    {/if}
    
  </div>
  
